import React, { useMemo } from 'react';

import Show from 'components/Show';
import { FinalMark } from 'components/Ui/Mark';

const Subject = ({ subject, subjects }) => {
	const assigned = useMemo(() => {
		return subjects.find(s => s.id === subject.id);
	}, [subject, subjects]);

	return (
		<td className="p-2 first:pl-3 group-one-last:first:rounded-bl-lg group-one-last:last:rounded-br-lg text-neutral-700 dark:text-neutral-200 text-sm font-bold border-neutral-100 dark:border-neutral-700 first:border-l border-r border-b group-one:first:rounded-bl-lg group-one:last:rounded-br-lg group-two-last:first:rounded-bl-lg group-two-last:last:rounded-br-lg">
			<Show if={assigned && assigned?.mark}>
				<FinalMark mark={assigned?.mark} />
			</Show>

			<Show if={assigned && !assigned?.mark}>
				<FinalMark />
			</Show>
		</td>
	);
};

export default Subject;